<template>
  <div>
    <component
      :is="layout + '-layout'"
      v-if="layout !==''"
    >
      <router-view />
      <SnackBar />
    </component>
    <DialogOutlet />
  </div>
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue'
import AuthLayout from './layouts/Auth.vue'
import SnackBar from '@/components/Snack_bar.vue'
import DialogOutlet from '@/plugins/dialog/DialogOutlet.vue'
import NoticeDialog from './components/NoticeDialog.vue'

export default {
  components: {
    DefaultLayout,
    AuthLayout,
    SnackBar,
    DialogOutlet
  },

  data: () => ({
  }),

  computed: {
    layout () {
      return this.$store.state.layout
    },
    hasError () {
      return this.$store.state.error.status
    }
  },
  errorCaptured (err) {
    if (err.data) {
      if (err.data.message) {
        this.newNoticeDialog(err.data.message)
        return
      }
      this.newNoticeDialog('Ocorreu um Erro na pagina, tente novamente mais tarde', true)
    }
    return false
  },
  watch: {
    hasError (value) {
      if (value) {
        this.newNoticeDialog(this.$store.state.error.msg)
      }
    }
  },
  methods: {
    async newNoticeDialog (message, goBack) {
      this.$dialog.custom(NoticeDialog).with({ title: 'Ops...', text: message }).show()
        .then(() => {
          if (goBack) {
            this.$router.go(-1)
          }
        })
    }
  }
}
</script>
